import { Pipe, PipeTransform } from '@angular/core';
import { StaticData } from '../helpers/static-data';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'bestdocFilter',
  pure: false // Hacer el pipe impuro para que se actualice con cambios de idioma
})
export class BestdocFilterPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(value: string, replaceWith: string = ''): string {
    if (!value) return value;

    // Si LogosBestDoc es false, reemplaza "BestDoc" con el texto alternativo
    if (!StaticData.LogosBestDoc) {
      // Si replaceWith tiene contenido, intentar traducirlo
      let translatedReplacement = replaceWith;
      if (replaceWith) {
        // Obtener la traducción del texto de reemplazo
        translatedReplacement = this.translateService.instant(replaceWith);
      }
      return value.replace(/BestDoc/gi, translatedReplacement);
    }

    return value;
  }
}
